import React, { createContext, useState, useEffect, useContext, useMemo } from 'react';
import {useLocation, useParams} from 'react-router-dom';
import { useCoreStateContext,useCoreContext } from 'spark-core-dx/contexts';
import { useCoreRoute } from 'spark-core-dx/hooks';
import ConvokeSourceObjectManager from '../../managers/convoke/ConvokeSourceObjectManager';
import ConvokeEntityObjectManager from '../../managers/convoke/ConvokeEntityObjectManager';
import { Operations } from '../../services/ItemServices';

export const ConvokeDomainContext = createContext();

export function ConvokeDomainContextProvider({ children }) {
    const coreState = useCoreStateContext();
    const coreContext = useCoreContext();
    const location = useLocation();
    const { eoId, soId } = useParams();
    const { currentRoute } = useCoreRoute('Convoke');
    const [loadingState, setLoadingState] = useState(true)
    const sourceObjectMgr = useMemo(() => {
        return new ConvokeSourceObjectManager(soId, coreContext, coreState, Operations.SourceObjectItem.SearchSourceObject, true);
    }, [soId, coreContext, coreState]);
    const entityObjectMgr = useMemo(() => {
        return new ConvokeEntityObjectManager(eoId, coreContext, coreState, Operations.EntityObjectItem.SearchEntityObject, true);
    }, [eoId, coreContext, coreState]);
    const routeKey = currentRoute?.ItemName ? `${currentRoute.ItemName}_data` : null;
    const routeState = routeKey ? coreState.get(routeKey) : null;
    const activeMgr = eoId ? entityObjectMgr : soId ? sourceObjectMgr : null;

    useEffect(() => {
        return () => {
            coreState.clear()
        }
    }, [])

    useEffect(() => {
        if (!routeState || routeState.loadingMetadata || routeState.loadingSearch) {
            setLoadingState(true)
        } else if (!activeMgr || !activeMgr.loading.All) {
            setLoadingState(false)
        }
    }, [location, routeState, activeMgr])


    return (
        <ConvokeDomainContext.Provider value={{ sourceObjectMgr,entityObjectMgr, loadingState: coreState.global.get('isNavigating') ? true : loadingState }}>
            {children}
        </ConvokeDomainContext.Provider>
    );
}
export const useConvokeDomainContext = () => useContext(ConvokeDomainContext);
